import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { authService } from './services/authService';
import { loginSuccess, logout } from './store/slices/authSlice';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import VmsApp from './pages/vms/VmsApp';
import DmsApp from './pages/dms/DmsApp';
import UserManagement from './pages/admin/UserManagement';
import { UserVendorList } from './pages/admin/UserVendorList';
import { UserDocumentList } from './pages/admin/UserDocumentList';
import { ProfilePage } from './pages/ProfilePage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { SnackbarProvider } from './contexts/SnackbarContext';
import './App.css';

function App() {
  const dispatch = useDispatch();
  const [isHydrating, setIsHydrating] = React.useState(true);

  useEffect(() => {
    const hydrateAuth = async () => {
      const token = authService.getAccessToken();
      if (token) {
        try {
          const userDetails = await authService.getMe();
          dispatch(loginSuccess({
            id: userDetails.id,
            username: userDetails.user_name,
            email: userDetails.email,
            first_name: userDetails.first_name,
            last_name: userDetails.last_name,
            role: userDetails.role || 'user',
            department: userDetails.department || 'Operations',
            status: userDetails.status,
            platform: userDetails.platform,
          }));
        } catch (err) {
          dispatch(logout());
        }
      }
      setIsHydrating(false);
    };
    hydrateAuth();
  }, [dispatch]);

  if (isHydrating) {
    return null;
  }

  return (
    <SnackbarProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/vms/*"
            element={
              <ProtectedRoute platform="vms">
                <VmsApp />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dms/*"
            element={
              <ProtectedRoute platform="dms">
                <DmsApp />
              </ProtectedRoute>
            }
          />
          <Route path="/admin/users" element={<UserManagement />} />
          <Route path="/admin/users/:id/vendors" element={<UserVendorList />} />
          <Route path="/admin/users/:id/documents" element={<UserDocumentList />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </SnackbarProvider>
  );
}

export default App;
